import styled from 'styled-components';

import { ReactComponent as RelaxedMascot } from '@wecasa/common/src/assets/svg/relaxed-mascot.svg';
import type { UniverseReference, User } from '@wecasa/common/src/types/commons';
import colors, { withOpacity } from '@wecasa/common/src/utils/colors';
import { toRem } from '@wecasa/common/src/utils/styles';

import { translate } from '@wecasa/i18n';

import Text from '@wecasa/web-ui/src/components/base-text/variants/text';

const t = translate('basket');

const NoContentYetWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  margin: 0 ${toRem(30)};
`;

const NoContentYetIcon = styled.div`
  margin-bottom: ${toRem(30)};
`;

const NoContentYetWelcome = styled(Text.LG)`
  margin-bottom: ${toRem(5)};
`;

type NoContentYetProps = {
  user?: User;
  universe: UniverseReference;
};

const NoContentYet = ({ user, universe }: NoContentYetProps) => (
  <NoContentYetWrapper>
    <NoContentYetIcon>
      <RelaxedMascot width={80} />
    </NoContentYetIcon>
    <NoContentYetWelcome centered color={withOpacity(colors.ink100, 0.5)} display='block'>
      {!user
        ? t('.no_content_yet.first_line.without_name')
        : t('.no_content_yet.first_line.with_name', { firstName: user.first_name })}
    </NoContentYetWelcome>
    <Text.LG centered color={withOpacity(colors.ink100, 0.5)} display='block'>
      {t(`.no_content_yet.second_line.${universe}`)}
    </Text.LG>
  </NoContentYetWrapper>
);

export default NoContentYet;
